import React from "react";
import { Prompt } from "react-router-dom";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// limitless import
import PortalButton from "../../buttons/portal-button/PortalButton";
import { useNavigation } from "../../../hooks/navigation/NavigationContext";
import Separator from "../separator/Separator";
const useStyles = makeStyles(theme => ({
  footerContainer: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    bottom: 0,
    width: "calc(100% - 298px)",
    backgroundColor: theme.background.paper,
    zIndex: 1200,
    "@media screen and (max-width: 1150px)": {
      width: "calc(100% - 48px)"
    },
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 16
  },
  buttonContainer: {
    display: "flex",
    "& > :first-child": {
      marginRight: 16
    }
  }
}));
const FooterContainer = ({
  children,
  onCancel,
  onSave,
  formError,
  formInfo,
  isFormInvalid,
  loading,
  saveButtonLabel,
  containerStyles = {},
  cancelButtonLabel = "Cancel",
  unSavedChanges = false,
  isCancelDisabled = false
}) => {
  const classes = useStyles();
  const container = {
    ...containerStyles
  };
  const [showChangeRoutePrompt, setShowChangeRoutePrompt] = React.useState(false);
  const {
    isNavigationExpanded,
    isLargeScreen
  } = useNavigation();
  if (isLargeScreen && !isNavigationExpanded) {
    container.width = "calc(100% - 48px)";
  }
  React.useEffect(() => setShowChangeRoutePrompt(unSavedChanges), [unSavedChanges]);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerContainer,
    style: container
  }, /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, typeof children === "object" ? children : formInfo ? /*#__PURE__*/React.createElement(Typography, null, formInfo) : /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, formError), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, onCancel && /*#__PURE__*/React.createElement(PortalButton, {
    onClick: onCancel,
    variant: "outlined",
    disabled: isCancelDisabled || loading,
    id: "cancelButton"
  }, cancelButtonLabel), /*#__PURE__*/React.createElement(PortalButton, {
    onClick: onSave,
    disabled: isFormInvalid || loading,
    id: "saveButtonChanges"
  }, saveButtonLabel)))), /*#__PURE__*/React.createElement(Prompt, {
    when: showChangeRoutePrompt,
    message: () => "You have unsaved changes, are you sure you want to navigate away?"
  }));
};
export default FooterContainer;
FooterContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  onCancel: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  formInfo: PropTypes.string,
  formError: PropTypes.string,
  isFormInvalid: PropTypes.bool,
  loading: PropTypes.bool,
  saveButtonLabel: PropTypes.string,
  containerStyles: PropTypes.object,
  cancelButtonLabel: PropTypes.string,
  unSavedChanges: PropTypes.bool,
  isCancelDisabled: PropTypes.bool
};